import angular from 'angular';

import AboutSettingsComponent from './about.cmpt';

export default angular
    .module('application.scene.authorized.scene.settings.scene.about', [])
    .component(AboutSettingsComponent.selector, AboutSettingsComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.about', {
        url: '/about',
        component: AboutSettingsComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/about/index.js